// @flow

import React from 'react';
import { connect } from 'react-redux';
import ActiveItem from '../activeItem';
import {
  getMethodsForActiveAccessory,
} from '../../../../../../store/configuration/actives';
import {
  getIncludingAbbreviation,
} from '../../../../../../store/configuratorSettings/selectors';
import {
  getMostImportantMethod,
} from '../../../../../../helpers';
import type { Accessory } from '../../../../../../types/pdb';

type OwnProps = {|
  active: Accessory,
  price: number,
|};

type StateProps = {|
  included: string,
  methods: string[],
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const ActiveAccessory = ({
  active, included, methods, price, ...props
}: Props) => {
  const method = getMostImportantMethod(methods);

  let priceProps = {};

  if (method === 'selected') {
    priceProps = {
      price,
    };
  } else {
    priceProps = {
      alternativePriceString: included,
    };
  }

  return (
    <ActiveItem
      type=""
      title={active.name}
      {...priceProps}
      {...props}
    />
  );
};

const mapStateToProps = (state: any, ownProps: OwnProps): StateProps => ({
  included: getIncludingAbbreviation(state),
  methods: getMethodsForActiveAccessory(state, ownProps.active.id),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(ActiveAccessory);
